import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const LockIcon = ({ type = 'brand', size = 'regular', styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { width: sizePx, height: sizePx, viewBox: "0 0 30 42", style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M-1065-1465H375V696h-1440z" }),
            React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round" },
                React.createElement("path", { d: "M28.05 27.577v12.585H1.833V18.355H28.05v9.222M3.659 18.355h14.568M5.78 18.355v-7.421c0-5.005 4.094-9.1 9.1-9.1 5.004 0 9.1 4.095 9.1 9.1v3.145" }),
                React.createElement("path", { d: "M17.25 26.864a2.371 2.371 0 11-4.742 0 2.371 2.371 0 014.743 0zM14.879 29.236v3.626" })))));
};
export default LockIcon;
//# sourceMappingURL=index.js.map